import React from 'react'
import { Button } from 'react-bootstrap'
import * as actions from '../redux/actions'
import { connect } from 'react-redux'

const baseCOAs = [
    {
        name: 'Income',
        slug: 'income',
        generalAccount: true,
        debitOrCreditOnGain: 'debit',
        subAccounts: [
            {
                name: 'Sales',
                slug: 'sales'
            }
        ]
    },
    {
        name: 'Expenses',
        slug: 'expenses',
        debitOrCreditOnGain: 'credit',
        generalAccount: true,
        subAccounts: [
            {
                name: 'Cost of Goods Sold',
                slug: 'cogs',
                debitOrCreditOnGain: 'credit'
            },
            {
                name: 'Operating Expenses',
                slug: 'operating_expenses',
                debitOrCreditOnGain: 'credit'
            }
        ]
    },
    {
        name: 'Assets',
        slug: 'assets',
        debitOrCreditOnGain: 'debit',
        generalAccount: true,
        subAccounts: [
            {
                name: 'Cash on Hand',
                slug: 'cash_on_hand'
            }
        ]
    },
    {
        name: 'Liabilities',
        slug: 'liabilities',
        debitOrCreditOnGain: 'credit',
        generalAccount: true,
    },
    {
        name: 'Equity',
        slug: 'equity',
        debitOrCreditOnGain: 'debit',
        generalAccount: true,
        subAccounts: [
            {
                name: 'Capital Stock',
                slug: 'capital_stock',
                debitOrCreditOnGain: 'debit'
            },
            {
                name: 'Retained Earnings',
                slug: 'retained_earnings',
                debitOrCreditOnGain: 'debit'
            }
        ]
    }
];

class AccountingChartOfAccounts extends React.PureComponent {

    // This renders the chart of accounts recursively
    recursiveMapAccounts = (accounts) => {
        let acc = accounts.map( account =>
            <div>
                <li>{account.name}</li> 
                {account.subAccounts && <ul>{this.recursiveMapAccounts(account.subAccounts)}</ul> }
            </div>
        );
        return acc;
    }

    renderCOA = (accounts) => {
        let acc = accounts.map( account =>
            <div>
                { account.generalAccount && <h2>{ account.name }</h2> }
                { !account.generalAccount && <p>{ account.name }</p> }
                { account.subAccounts && this.renderCOA(account.subAccounts) }
            </div>
        )
        acc.push(<Button>Create New</Button>)
        return acc
    }

    render() {
        return (
            <div className="App">
                <h1>Chart of Accounts</h1>
                <ul>{/*this.recursiveMapAccounts(baseCOAs)*/}</ul>
                <p>{this.renderCOA(baseCOAs)}</p>
            </div>
        );
    }
}

function mapStateToProps({ auth, configApp }) {
    return {
        token: auth.token,
        userData: auth.userData,
        configApp: configApp,
    }
}

export default connect(mapStateToProps, actions)(AccountingChartOfAccounts)